import { render, staticRenderFns } from "./SocietySciencePanel.vue?vue&type=template&id=11a3cb41&scoped=true"
import script from "./SocietySciencePanel.vue?vue&type=script&lang=js"
export * from "./SocietySciencePanel.vue?vue&type=script&lang=js"
import style0 from "./SocietySciencePanel.vue?vue&type=style&index=0&id=11a3cb41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a3cb41",
  null
  
)

export default component.exports